export default function toggleCareer() {
	const toggleButtons = document.querySelectorAll(".ex_career-case_toggle");
	toggleButtons.forEach((el,n) => {
		const btn = el;
		const content = document.querySelector(`[data-id=${btn.dataset.target}]`);

		const height = content.clientHeight;
		content.dataset.height = height + 500;
		content.style.maxHeight = 0;
		
		el.addEventListener("click", (e)=> {
			const btn = e.target;
			const content = document.querySelector(`[data-id=${btn.dataset.target}]`);
			if (!btn.classList.contains("is-open")) {
				const maxHeight = content.dataset.height + "px";
				content.style.maxHeight = maxHeight;
				btn.classList.add("is-open");
				content.classList.add("is-open");
				btn.innerHTML = "CLOSE -";
			} else {
				btn.classList.remove("is-open");
				content.classList.remove("is-open");
				btn.innerHTML = "VIEW MORE +";
				content.style.maxHeight = 0;
			}
		});
	});
}